import styled from 'styled-components'

import { mq, sizes } from '../../theme'
import ActionButton from '../ActionButton'
import { WysiwygContainer } from '../WysiwygRenderer/styled'

export const SectionTitle = styled.h2`
  ${({ theme }) => theme.textStyles.titleH2_23}
  padding: 0;
  margin: 0;
  text-align: center;

  &::first-letter {
    text-transform: uppercase;
  }

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.titleH2_30}
  }
`

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  & > * {
    margin-top: 3rem;
    @media print {
      margin-top: 1rem;
    }
  }
  background-color: '#FFED9F';
  @media ${mq(sizes.desktop)} {
    & > * {
      margin-top: 4rem;
    }
  }
`

export const FullscreenStepsButton = styled(ActionButton)`
  justify-self: center;
  color: ${({ theme }) => theme.colors.pureWhite};
  align-self: center;
  @media ${mq(sizes.desktop)} {
    display: none;
  }
  @media print {
    display: none;
  }
`

export const StepsContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 60rem;
  align-self: center;
  gap: 2rem;
  @media ${mq(sizes.desktop)} {
    margin-bottom: 6.5rem;
    gap: 4rem;
  }
  @media print {
    gap: 0.5rem;
    margin-bottom: 0;
    max-width: initial;
    align-self: flex-start;
  }
`

export const Step = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  min-height: 5rem;
  align-items: center;

  @media ${mq(sizes.desktop)} {
    min-height: 7rem;
  }
  @media print {
    min-height: 0;
  }
`

export const StepNumber = styled.div`
  ${({ theme }) => theme.textStyles.text_bold_32}
  color: ${({ theme }) => theme.colors.redMojo};
  padding-right: 2rem;
  min-width: 6rem;
  text-align: right;

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_bold_50}
    padding-right: 4rem;
    min-width: 10.6rem;
  }
`
export const StepSeparator = styled.div`
  display: flex;
  background: ${({ theme }) => theme.colors.pink};
  align-self: stretch;
  flex-shrink: 0;
  width: 0.4rem;
  margin: 0 2rem 0 0;

  @media ${mq(sizes.desktop)} {
    width: 0.6rem;
    margin: 0 4rem 0 0;
  }

  @media print {
    display: none;
  }
`
export const StepText = styled(WysiwygContainer)`
  span:empty,
  p:empty {
    display: block;
    margin-top: 1rem;
  }
`
